<div class="wrapper">
  <!-- The drawings detail header (Figma 33128:76594): ‹ back, the sheet, its revision and stations, its badges, the ••• -->
  <app-drawings-page-header [title]="viewerTitle" backLabel="Back to Drawings" backTestId="drawing-viewer-back" titleTestId="drawing-viewer-title"
    (back)="back.emit()">
    @if (revision) {
      <button headerMenu type="button" mat-icon-button class="more-button" data-testid="drawing-viewer-more" aria-label="More actions" [matMenuTriggerFor]="moreMenu"><mat-icon>more_horiz</mat-icon></button>
    }
    @if (revision) {
      <p headerSub class="viewer-subtitle">Rev {{ revision.label }}@if (sheetMeta) {<span data-testid="drawing-viewer-sheet-meta"> · {{ sheetMeta }}</span>}</p>
    }
    @if (revision && byStationsText) {
      <p headerSub class="viewer-subtitle secondary-text" data-testid="drawing-viewer-by-stations">{{ byStationsText }}</p>
    }
    @if (revision) {
      <div headerChips class="viewer-chips">
        <span class="status-badge" [ngClass]="statusBadge[revision.status]" data-testid="drawing-viewer-status">{{ statusCopy[revision.status] }}</span>
        @switch (mapState) {
          @case ('failed') {
            <span class="status-badge status-badge--error" data-testid="drawing-viewer-map-state">Placement failed</span>
          }
          @case ('newer') {
            <span class="status-badge status-badge--warning" data-testid="drawing-viewer-map-state">Newer revision issued</span>
          }
          @case ('processing') {
            <span class="status-badge status-badge--info" data-testid="drawing-viewer-map-state">Placing on map…</span>
          }
          @case ('review') {
            @if (!canPlace) {
              <span class="status-badge status-badge--info" data-testid="drawing-viewer-map-state">Placement in review</span>
            }
          }
          @case ('placed') {
            <span class="status-badge" [class.status-badge--success]="placedText === 'Placed'" [class.status-badge--warning]="placedText !== 'Placed'"
              data-testid="drawing-viewer-map-state">{{ placedText }}</span>
          }
        }
      </div>
    }
    @if (revision && (canRedline || redlining)) {
      <app-primary-button headerActions buttonId="drawing-viewer-redline" (handleClick)="toggleRedline()">{{ redlining ? 'Done redlining' : 'Redline' }}</app-primary-button>
    }
  </app-drawings-page-header>

  <!-- The ⋯ menus at the top level: the header's ⋯ (projected) and the full-screen toolbar's both open them -->
  <mat-menu #moreMenu="matMenu" class="tab-more-menu" xPosition="before">
    @if (revision) {
      @if (canEditSheet && !sheetDraft) {
        <button mat-menu-item type="button" data-testid="drawing-viewer-edit-sheet" (click)="startEditSheet()">Edit sheet</button>
      }
      @if (canUploadRevision) {
        <button mat-menu-item type="button" data-testid="drawing-viewer-upload-revision" (click)="uploadRevision()">Upload new revision</button>
      }
      @if (canWithdrawCurrent) {
        <button mat-menu-item type="button" data-testid="drawing-viewer-withdraw" (click)="withdrawCurrent()">Withdraw Rev {{ sheet.current.label }}</button>
      }
      @switch (mapState) {
        @case ('place') {
          <button mat-menu-item type="button" data-testid="drawing-viewer-place" (click)="openPlace()">Place on map</button>
        }
        @case ('failed') {
          <button mat-menu-item type="button" data-testid="drawing-viewer-place" (click)="openPlace()">Place on map</button>
        }
        @case ('newer') {
          @if (canPlace) {
            <button mat-menu-item type="button" data-testid="drawing-viewer-place" (click)="openPlace()">Place Rev {{ revision.label }}</button>
          }
        }
        @case ('review') {
          @if (canPlace) {
            <button mat-menu-item type="button" data-testid="drawing-viewer-review-placement" (click)="reviewPlacement()">Review placement</button>
          }
          @if (canDiscardPlacement) {
            <button mat-menu-item type="button" data-testid="drawing-viewer-discard-placement" (click)="discardPlacement()">Discard placement</button>
          }
        }
        @case ('placed') {
          @if (mapLayer) {
            <button mat-menu-item type="button" data-testid="drawing-viewer-show-on-map" (click)="showOnMap()">Show on map</button>
          }
          @if (canRemoveFromMap) {
            <button mat-menu-item type="button" data-testid="drawing-viewer-remove-from-map" (click)="removeFromMap()">Remove from map</button>
          }
        }
      }
      @if (revision.supersedes_uuid) {
        <button mat-menu-item type="button" data-testid="drawing-viewer-compare" (click)="openCompare()">Compare with Rev {{ previousLabel }}</button>
      }
      @if (carryCount > 0) {
        <button mat-menu-item type="button" data-testid="drawing-viewer-review-carry" (click)="reviewCarry()">Review carried redlines</button>
      }
      <!-- W72: this sheet only; whole-set downloads live in the register's Export -->
      <button mat-menu-item type="button" data-testid="drawing-viewer-download" [disabled]="!!downloadingMode"
              [attr.aria-busy]="!!downloadingMode" [matMenuTriggerFor]="downloadMenu" appSubmenuDirection>
        {{ downloadingMode ? 'Downloading this sheet…' : 'Download this sheet' }}
      </button>
    }
  </mat-menu>
  <!-- Opens to the right when there is room; the caret follows wherever it opens (appSubmenuDirection) -->
  <mat-menu #downloadMenu="matMenu" class="tab-more-menu tab-more-submenu" xPosition="after">
    @if (revision) {
      @for (m of downloadModes; track m.mode) {
        <button mat-menu-item type="button" [attr.data-testid]="'drawing-viewer-download-' + m.mode" [disabled]="!!downloadingMode"
                (click)="downloadSheet(m.mode)">{{ m.label }}</button>
      }
    }
  </mat-menu>
  @if (revision) {

    @if (banner) {
      <div class="banner mat-body-1" role="status" data-testid="drawing-viewer-banner">
        <mat-icon>info_outline</mat-icon>
        <span>
          @if (banner === 'superseded') {
            This revision was superseded@if (currentLabel) { by Rev {{ currentLabel }}}.
          } @else {
            This revision was withdrawn.
          }
        </span>
        @if (hasOtherCurrent) {
          <button type="button" class="link-button" data-testid="drawing-viewer-open-current" (click)="openCurrent()">Open current</button>
        }
      </div>
    }

    @if (carryCount > 0) {
      <div class="hint mat-body-1" role="status" data-testid="drawing-viewer-carry">
        <span>{{ carryCount }} {{ carryCount === 1 ? 'redline' : 'redlines' }} from Rev {{ carryFromLabel }} {{ carryCount === 1 ? 'needs' : 'need' }} review</span>
        <button type="button" class="link-button" (click)="reviewCarry()">Review</button>
      </div>
    }

    <!-- W56: full screen is this same view in the map photo overlay's shell (dark backdrop, ✕, Esc), so zoom, filters and the selection stay.
         Not aria-modal: the Add to drawer (outside this element) slides over it and must stay reachable. -->
    <div class="viewer-body" [class.viewer-body--full]="fullScreen" data-testid="drawing-viewer-body" [attr.role]="fullScreen ? 'dialog' : null"
      [attr.aria-label]="fullScreen ? 'Sheet, full screen' : null">
      @if (fullScreen) {
        <button type="button" mat-icon-button class="full-close" aria-label="Close full screen" data-testid="drawing-viewer-full-close"
          (click)="toggleFullScreen(false)"><mat-icon>close</mat-icon></button>
      }
      <section class="stage">
        <div class="stage-bar stage-bar--counts mat-body-1">
          <!-- Once the rows load: the revision's summary counts as-built marks as shared -->
          <span class="secondary-text" data-testid="drawing-viewer-counts">@if (layers) {Redlines: {{ counts.shared }} shared · {{ counts.mine }} private@if (counts.asBuilt) { · {{ counts.asBuilt }} as-built}}</span>
        </div>
        <div class="stage-bar">
          <!-- W54: one Filter (N) (the shared multi-section filter, as the register): Markup, Records and Show -->
          <div class="stage-tools">
            @if (fullScreen) {
              <span class="full-title mat-body-1" data-testid="drawing-viewer-full-title">{{ revision.sheet?.number }} · Rev {{ revision.label }}</span>
            }
            <app-project-details-page-multi-section-filter data-testid="drawing-viewer-filter" [sections]="viewFilterSections"
              (selectionChange)="onViewFilterChange($event)" />
            @if (addToTypes.length) {
              <!-- W60: says what it does; the tooltip says where it goes -->
              <button type="button" class="tool-button tool-button--icon" data-testid="drawing-viewer-add-to" [class.tool-button--on]="placing"
                [attr.aria-pressed]="placing" matTooltip="Pin a new issue, RFI or punch item to a spot on this sheet" (click)="startAddTo()"><mat-icon>add_location_alt</mat-icon>Add record</button>
            }
            <button type="button" class="icon-button" aria-label="Find on sheet" data-testid="drawing-viewer-find-toggle" [class.icon-button--on]="findOpen"
              [attr.aria-pressed]="findOpen" matTooltip="Find on sheet" (click)="toggleFind()"><mat-icon>search</mat-icon></button>
            <!-- W66: zoom and Full screen are the map's stack, bottom-right of the sheet -->
            @if (fullScreen) {
              <button type="button" class="tool-button" data-testid="drawing-viewer-details-toggle" [class.tool-button--on]="detailsOpen"
                [attr.aria-pressed]="detailsOpen" aria-controls="drawing-viewer-details" (click)="toggleDetails()">Details</button>
              <!-- W64: the heading's ⋯ (Edit sheet, Place on map, …) is behind the overlay; the same menu from here -->
              <button type="button" class="icon-button" aria-label="More actions" data-testid="drawing-viewer-full-more" [matMenuTriggerFor]="moreMenu"><mat-icon>more_horiz</mat-icon></button>
            }
          </div>
        </div>
        @if (findOpen) {
          <!-- Find on sheet (W44): the list toolbar's 44px search pill, with the match count and previous / next -->
          <div class="find-bar" data-testid="drawing-viewer-find">
            <div class="search">
              <mat-icon svgIcon="search"></mat-icon>
              <input #findInput class="search-input" type="text" maxlength="128" placeholder="Find on this sheet" aria-label="Find on this sheet" data-testid="drawing-viewer-find-input"
                [value]="findQuery" (keydown.enter)="findMatches.length && findQuery === findInput.value ? findStep($event.shiftKey ? -1 : 1) : runFind(findInput.value)"
                (keydown.escape)="toggleFind()" />
              @if (findQuery) { <mat-icon svgIcon="close" role="button" aria-label="Clear" (click)="findInput.value = ''; runFind('')"></mat-icon> }
            </div>
            <span class="find-count mat-body-1" role="status" data-testid="drawing-viewer-find-count">
              @if (findBusy) { Searching… } @else if (findMatches.length) { {{ findIndex + 1 }} of {{ findMatches.length }} } @else if (findError) { {{ findError }} }
            </span>
            <button type="button" class="icon-button" aria-label="Previous match" data-testid="drawing-viewer-find-prev" [disabled]="findMatches.length < 2" (click)="findStep(-1)"><mat-icon>keyboard_arrow_up</mat-icon></button>
            <button type="button" class="icon-button" aria-label="Next match" data-testid="drawing-viewer-find-next" [disabled]="findMatches.length < 2" (click)="findStep(1)"><mat-icon>keyboard_arrow_down</mat-icon></button>
            <button type="button" class="link-button" (click)="toggleFind()">Close</button>
          </div>
        }
        @if (placing) {
          <div class="hint mat-body-1" role="status" data-testid="drawing-viewer-add-hint">
            <span>{{ pageLoaded ? 'Click the spot where the new record goes · Esc to cancel' : 'Loading sheet…' }}</span>
            <button type="button" class="link-button" (click)="cancelAddTo()">Cancel</button>
          </div>
        }
        @if (locationHint || offSheet || (showLocation && approximateText)) {
          <div class="location-line mat-body-1" role="status" data-testid="drawing-viewer-location">
            @if (showLocation && approximateText) {
              <span class="status-badge status-badge--warning" data-testid="drawing-viewer-approx">{{ approximateText }}</span>
            }
            @if (offSheet) {
              <span class="ph-no-capture" data-sentry-block data-testid="drawing-viewer-off-sheet">{{ offSheet.text }}</span>
            }
            @if (locationHint) {
              <span class="secondary-text" data-testid="drawing-viewer-location-hint">{{ locationHint }}</span>
            }
          </div>
        }
        @if (marksCapped) {
          <div class="secondary-text mat-caption cap-line" data-testid="drawing-viewer-marks-cap">Showing the {{ marksCap }} most recent record marks.</div>
        }
        @if (linkedTotal > markerCap) {
          <div class="secondary-text mat-caption cap-line" data-testid="drawing-viewer-marker-cap">Showing the first {{ markerCap }} markers.</div>
        }
        <!-- W66: the frame's shell holds the map-style zoom stack over the scrolling frame, bottom-right -->
        <div class="frame-shell">
        <!-- W55: ctrl / ⌘ + wheel and pinch zoom at the cursor; drag pans once zoomed (a short drag is still a click) -->
        <div #pageFrame class="page-frame" cdkScrollable [class.page-frame--zoomed]="zoom > 1" [class.page-frame--placing]="placing" data-testid="drawing-viewer-frame"
          (wheel)="onFrameWheel($event)" (pointerdown)="onFramePointerDown($event)" (pointermove)="onFramePointerMove($event)"
          (pointerup)="onFramePointerUp($event)" (pointercancel)="onFramePointerUp($event)" (lostpointercapture)="onFrameCaptureLost()"
          (gesturestart)="onFrameGestureStart($event)" (gesturechange)="onFrameGestureChange($event)" (gestureend)="onFrameGestureEnd($event)">
          @if (revision.preview_url) {
            <div class="page" [class.page--zoomed]="pageWidthPx" [class.page--placing]="placing" [class.page--loading]="!pageLoaded" [class.page--expand]="clickToFull"
              (pointermove)="onPagePointerMove($event)" (pointerleave)="ghostPin = null"
              [style.width.px]="pageWidthPx">
              <img #pageImage class="page-image" data-testid="drawing-viewer-page" [src]="revision.preview_url" [alt]="revision.sheet?.number + ' Rev ' + revision.label"
                draggable="false" [attr.tabindex]="placing || clickToFull ? 0 : null" [attr.role]="placing || clickToFull ? 'button' : null"
                [attr.aria-label]="placing ? 'Place the record on the sheet. Arrow keys move the point, Enter picks the record type.' : clickToFull ? 'Open sheet in full screen' : null"
                (load)="onPageLoad()" (click)="onPageClick($event)" (keydown)="onPageKey($event)" />
              @for (layer of visibleLayers; track layer.id) {
                <img class="page-layer" data-testid="drawing-viewer-layer" [src]="layer.preview_url" alt="" decoding="async" />
              }
              @for (layer of asBuiltLayers; track layer.id) {
                <img class="page-layer" data-testid="drawing-viewer-as-built-layer" [src]="layer.preview_url" alt="" decoding="async" />
              }
              <div class="marker-layer">
                @for (b of findMatches; track $index) {
                  <span class="find-hit" data-testid="drawing-viewer-find-hit" [class.find-hit--current]="$index === findIndex"
                    [style.left.%]="b.x * 100" [style.top.%]="b.y * 100" [style.width.%]="b.w * 100" [style.height.%]="b.h * 100"></span>
                }
                @if (here && !redlining) {
                  @if (here.inside) {
                    <span class="fix-accuracy ph-no-capture" data-sentry-block data-testid="drawing-viewer-fix-accuracy" [style.left.%]="here.x * 100" [style.top.%]="here.y * 100"
                      [style.width.%]="accuracyR * 200"></span>
                    <span class="fix-dot ph-no-capture" data-sentry-block data-testid="drawing-viewer-fix" role="img" aria-label="You are here" [style.left.%]="here.x * 100" [style.top.%]="here.y * 100"></span>
                  } @else if (offSheet) {
                    <span class="fix-arrow ph-no-capture" data-sentry-block data-testid="drawing-viewer-fix-arrow" role="img" [attr.aria-label]="offSheet.text"
                      [style.left.%]="offSheet.edgeX * 100" [style.top.%]="offSheet.edgeY * 100" [style.transform]="'translate(-50%, -50%) rotate(' + offSheet.angle + 'deg)'"></span>
                  }
                }
                @for (m of recordMarkHits; track m.row.id) {
                  <!-- W76: another record's marks: a click opens its card, as its marker does -->
                  <button type="button" class="record-mark-hit" data-testid="drawing-viewer-record-mark" [attr.data-link-uuid]="m.record.uuid"
                    [style.left.%]="m.box.x0 * 100" [style.top.%]="m.box.y0 * 100"
                    [style.width.%]="(m.box.x1 - m.box.x0) * 100" [style.height.%]="(m.box.y1 - m.box.y0) * 100" [attr.tabindex]="placing ? -1 : null"
                    [attr.aria-label]="'Marks of ' + (m.record.label || noun(m.record.entity_type)) + ': open its card'"
                    (click)="selectMarker(m.record, $event)"></button>
                }
                @for (m of asBuiltMarks; track m.row.id) {
                  <button type="button" class="mark-outline" data-testid="drawing-viewer-mark" [attr.data-mark-id]="m.row.id"
                    [attr.data-status]="m.row.review_status" [class.mark-outline--selected]="selectedMark?.id === m.row.id"
                    [style.left.%]="m.box.x0 * 100" [style.top.%]="m.box.y0 * 100"
                    [style.width.%]="(m.box.x1 - m.box.x0) * 100" [style.height.%]="(m.box.y1 - m.box.y0) * 100" [attr.tabindex]="placing ? -1 : null"
                    [attr.aria-label]="'As-built mark' + (authorName(m.row) ? ' by ' + authorName(m.row) : '') + ', ' + (markStatusCopy[m.row.review_status] || 'Open')"
                    [attr.aria-expanded]="selectedMark?.id === m.row.id" (click)="selectMark(m.row, $event)"></button>
                }
                @for (row of markers; track row.uuid) {
                  <button type="button" class="sheet-marker" data-testid="drawing-viewer-marker" [attr.data-marker-uuid]="row.uuid"
                    [class.sheet-marker--open]="isOpen(row.status)" [class.sheet-marker--selected]="selected?.uuid === row.uuid"
                    [style.left.%]="row.point.x * 100" [style.top.%]="row.point.y * 100" [attr.tabindex]="placing ? -1 : null"
                    [attr.aria-label]="'Marker ' + row.marker_index + ': ' + (row.label || noun(row.entity_type))"
                    (click)="selectMarker(row, $event)">{{ row.marker_index }}</button>
                }
                @if (ghostPin) {
                  <!-- W60: placing, the pin follows the pointer to show exactly where the record will go (not on touch: the tap places) -->
                  <span class="drawer-pin ghost-pin" data-testid="drawing-viewer-ghost-pin" aria-hidden="true"
                    [style.left.%]="ghostPin.x * 100" [style.top.%]="ghostPin.y * 100">
                    <img src="/assets/icons/map/markers/location-pin-filled.svg" alt="" draggable="false" />
                  </span>
                }
                @if (focusPulse) {
                  <!-- W70: the point a record's card asked for, pulsing for a moment -->
                  <span class="focus-pulse" data-testid="drawing-viewer-focus-pulse" aria-hidden="true"
                    [style.left.%]="focusPulse.x * 100" [style.top.%]="focusPulse.y * 100"></span>
                }
                @if (drawerPin && !pendingPoint) {
                  <!-- W55: where the record being created in the drawer goes; it becomes its numbered marker on save -->
                  <span class="drawer-pin" data-testid="drawing-viewer-drawer-pin" role="img" aria-label="The new record's place on the sheet"
                    [style.left.%]="drawerPin.x * 100" [style.top.%]="drawerPin.y * 100">
                    <img src="/assets/icons/map/markers/location-pin-filled.svg" alt="" draggable="false" />
                  </span>
                }
                @if (pendingPoint) {
                  <span class="pending-pin" data-testid="drawing-viewer-pending" [style.left.%]="pendingPoint.x * 100" [style.top.%]="pendingPoint.y * 100"
                    #addTrigger="matMenuTrigger" [matMenuTriggerFor]="addMenu" (menuClosed)="onAddMenuClosed()"></span>
                }
                @if (!redlining && peekAt; as at) {
                  <div class="peek" role="dialog" aria-label="Linked record" data-testid="drawing-viewer-peek"
                    [class.peek--left]="at.x > 0.6" [class.peek--up]="at.y > 0.6"
                    [style.left.%]="at.x * 100" [style.top.%]="at.y * 100">
                    <div class="peek-head">
                      <span class="peek-marker" [class.sheet-marker--open]="isOpen(selected.status)">{{ selected.marker_index }}</span>
                      <span class="peek-title" data-testid="drawing-viewer-peek-label">{{ selected.label || noun(selected.entity_type) }}</span>
                      <button type="button" class="peek-close" aria-label="Close" (click)="closePeek()"><mat-icon>close</mat-icon></button>
                    </div>
                    <div class="peek-meta mat-caption">
                      {{ noun(selected.entity_type) }}@if (selected.status) { · <span data-testid="drawing-viewer-peek-status">{{ selected.status | titlecase }}</span>}
                    </div>
                    <div class="peek-meta mat-caption">
                      @if (selected.created_by?.name) {<span>{{ selected.created_by.name }}</span> · }{{ selected.created_at | date: 'MMM d, y' }}
                    </div>
                    <div class="peek-actions">
                      <button type="button" class="link-button" data-testid="drawing-viewer-peek-open" [disabled]="!canOpen(selected)" (click)="openRecord(selected)">Open</button>
                      @if (canEditSelectedMarkup) {
                        <!-- W76: the record's marks, in the editor -->
                        <button type="button" class="link-button" data-testid="drawing-viewer-peek-edit-markup" (click)="editRecordMarkup()">Edit markup</button>
                      }
                    </div>
                  </div>
                }
              </div>
            </div>
          } @else {
            <div class="empty-state mat-body-1">This page has no preview yet.</div>
          }
        </div>
        <app-sheet-zoom-controls testIdPrefix="drawing-viewer" [zoom]="zoom" [canZoomIn]="canZoomIn && !!revision.preview_url" [canZoomOut]="canZoomOut"
          [fullScreen]="fullScreen" (zoomIn)="zoomBy(1)" (zoomOut)="zoomBy(-1)" (fullScreenChange)="toggleFullScreen($event)" />
        </div>
        <!-- The mark card floats over the page in an overlay anchored to its outline, so it is never clipped by the scrolling frame -->
        <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="markOrigin!" [cdkConnectedOverlayOpen]="!!selectedMark && !!markOrigin && !redlining"
          [cdkConnectedOverlayPositions]="markCardPositions" [cdkConnectedOverlayPush]="true" [cdkConnectedOverlayViewportMargin]="16"
          [cdkConnectedOverlayScrollStrategy]="markCardScroll" (attach)="onMarkCardAttached()" (detach)="onMarkCardDetached()" (overlayOutsideClick)="onMarkCardOutsideClick($event)"
          (overlayKeydown)="onMarkCardKeydown($event)">
          @if (selectedMark) {
            <div class="mark-card" role="dialog" aria-label="As-built mark" tabindex="-1" data-testid="drawing-viewer-mark-card" #markCard>
              <div class="mark-card-body">
                <div class="peek-head">
                  <span class="peek-title">As-built</span>
                  <span class="status-badge mark-chip" [attr.data-status]="selectedMark.review_status" data-testid="drawing-viewer-mark-status">
                    {{ markStatusCopy[selectedMark.review_status] || 'Open' }}</span>
                  <button type="button" class="peek-close" aria-label="Close" (click)="closeMark()"><mat-icon>close</mat-icon></button>
                </div>
                <div class="peek-meta mat-caption" data-testid="drawing-viewer-mark-author">
                  @if (authorName(selectedMark)) {<span>{{ authorName(selectedMark) }}</span> · }{{ selectedMark.created_at | date: 'MMM d, y' }}
                </div>
                @if (selectedMarkRecord) {
                  <!-- 7.2: the record the mark was made from; its review stays independent of the record's status -->
                  <div class="peek-meta mat-caption" data-testid="drawing-viewer-mark-record">
                    @if (canOpenMarkRecord) {
                      <button type="button" class="link-button" data-testid="drawing-viewer-mark-record-open" (click)="openMarkRecord()">{{ selectedMarkRecord }}</button>
                    } @else {
                      {{ selectedMarkRecord }}
                    }
                  </div>
                }
                @if (selectedMark.carried_from_uuid) {
                  <div class="peek-meta mat-caption">Carried forward from an earlier revision</div>
                }
                @if (incorporatedLabel !== null) {
                  <div class="peek-meta mat-caption" data-testid="drawing-viewer-mark-incorporated">Incorporated in {{ incorporatedLabel ? 'Rev ' + incorporatedLabel : 'a later revision' }}</div>
                }
                @if (selectedMark.last_review; as last) {
                  <div class="mark-review mat-caption" data-testid="drawing-viewer-mark-review">
                    <span class="peek-meta">Last review: {{ last.actor?.name || 'Someone' }} · {{ last.at | date: 'MMM d, y' }}</span>
                    @if (last.comment) {
                      <span class="mark-comment">{{ last.comment }}</span>
                    }
                  </div>
                }
                @if (markHistory.length) {
                  <button type="button" class="link-button mark-history-toggle" data-testid="drawing-viewer-mark-history-toggle"
                    [attr.aria-expanded]="showMarkHistory" (click)="showMarkHistory = !showMarkHistory">{{ showMarkHistory ? 'Hide history' : 'History' }}</button>
                  @if (showMarkHistory) {
                    <ol class="mark-history mat-caption" data-testid="drawing-viewer-mark-history">
                      @for (e of markHistory; track $index) {
                        <li>
                          <span>{{ e.text }}</span>
                          <span class="peek-meta">{{ e.actor }}@if (e.actor) { · }{{ e.at | date: 'MMM d, y, h:mm a' }}</span>
                          @if (e.comment) {
                            <span class="mark-comment">{{ e.comment }}</span>
                          }
                        </li>
                      }
                    </ol>
                  }
                }
                @if (markAction === 'rejected') {
                  <app-text-area class="mark-field" data-testid="drawing-viewer-mark-comment" [parentFormGroup]="markForm" controlName="comment"
                    label="Why is it rejected?" [maxLength]="2000" />
                }
                @if (markAction === 'incorporated') {
                  @if (incorporateTargets.length) {
                    <label class="mark-field">
                      <span class="sheet-label mat-caption">Incorporated in</span>
                      <select class="sheet-input mat-body-1" data-testid="drawing-viewer-mark-revision" [disabled]="reviewing"
                        (change)="markRevision = $any($event.target).value">
                        @for (t of incorporateTargets; track t.uuid) {
                          <option [value]="t.uuid" [selected]="t.uuid === markRevision">Rev {{ t.label }}</option>
                        }
                      </select>
                    </label>
                    <app-text-area class="mark-field" data-testid="drawing-viewer-mark-comment" [parentFormGroup]="markForm" controlName="comment"
                      label="Comment (optional)" [maxLength]="2000" />
                  } @else {
                    <span class="peek-meta mat-caption" data-testid="drawing-viewer-mark-no-later">No later revision of this sheet yet.</span>
                  }
                }
                @if (markError) {
                  <span class="sheet-error mat-caption" role="alert" data-testid="drawing-viewer-mark-error">{{ markError }}</span>
                }
              </div>
              @if (markAction) {
                <div class="peek-actions">
                  @if (markAction === 'rejected' || incorporateTargets.length) {
                    <button type="button" class="tool-button tool-button--on" data-testid="drawing-viewer-mark-confirm" [disabled]="reviewing"
                      (click)="submitMarkAction()">{{ markActionCopy[markAction] }}</button>
                  }
                  <button type="button" class="link-button" data-testid="drawing-viewer-mark-cancel" [disabled]="reviewing" (click)="cancelMarkAction()">Cancel</button>
                </div>
              } @else if (markActions.length || canChangeMark || canDeleteMark || markOwnerLocked) {
                <div class="peek-actions">
                  @if (primaryMarkAction; as primary) {
                    <button type="button" class="tool-button tool-button--on" [attr.data-testid]="'drawing-viewer-mark-' + primary" [disabled]="reviewing"
                      (click)="startReview(primary)">{{ markActionCopy[primary] }}</button>
                  }
                  @if (moreMarkActions.length || canChangeMark || canDeleteMark || markOwnerLocked) {
                    <button type="button" class="icon-button" aria-label="More mark actions" data-testid="drawing-viewer-mark-more" [disabled]="reviewing"
                      [matMenuTriggerFor]="markMenu"><mat-icon>more_horiz</mat-icon></button>
                  }
                </div>
              }
            </div>
          }
        </ng-template>
        <mat-menu #markMenu="matMenu" class="tab-more-menu" xPosition="before">
          @for (a of moreMarkActions; track a) {
            <button mat-menu-item type="button" [attr.data-testid]="'drawing-viewer-mark-' + a" (click)="startReview(a)">{{ markActionCopy[a] }}</button>
          }
          @if (canChangeMark) {
            <button mat-menu-item type="button" data-testid="drawing-viewer-mark-edit" (click)="editMark()">Edit</button>
          }
          @if (canDeleteMark) {
            <button mat-menu-item type="button" data-testid="drawing-viewer-mark-delete" (click)="deleteMark()">Delete</button>
          }
          @if (markOwnerLocked) {
            <!-- W59: someone else's mark; the span carries the tooltip (a disabled item gets no pointer events) -->
            <span class="locked-items" data-testid="drawing-viewer-mark-locked" [matTooltip]="markOwnerCopy" matTooltipPosition="left">
              @for (item of lockedMarkItems; track item) {
                <button mat-menu-item type="button" disabled>{{ item }}</button>
              }
            </span>
          }
        </mat-menu>
        <mat-menu #addMenu="matMenu" class="tab-more-menu">
          <div class="menu-header mat-caption" data-testid="drawing-viewer-add-header">Add here:</div>
          @for (t of addToTypes; track t.type) {
            <button mat-menu-item type="button" [attr.data-testid]="'drawing-viewer-add-' + t.type" (click)="addTo(t.type)">{{ t.label }}</button>
          }
        </mat-menu>
      </section>

      <aside class="history" id="drawing-viewer-details" data-testid="drawing-viewer-details" [class.history--open]="detailsOpen"
        aria-label="Revision history and linked records">
        <h3 class="section-title">History</h3>
        @for (rev of sheet?.revisions ?? []; track rev.uuid) {
          <button type="button" class="history-item" data-testid="drawing-viewer-history-item" [class.history-item--open]="rev.uuid === revision.uuid"
            [attr.aria-current]="rev.uuid === revision.uuid ? 'page' : null" (click)="selectRevision(rev.uuid)">
            <span class="history-line">
              <span class="history-label">Rev {{ rev.label }}</span>
              <span class="status-badge" [ngClass]="statusBadge[rev.status]" data-testid="drawing-viewer-history-status">{{ statusCopy[rev.status] }}</span>
            </span>
            <span class="secondary-text mat-caption" data-testid="drawing-viewer-history-when">{{ historyWhen(rev) }}</span>
            @if (rev.issue_set?.notes) {
              <span class="history-notes mat-caption" data-testid="drawing-viewer-history-notes">{{ rev.issue_set.notes }}</span>
            }
          </button>
          @if (rev.uuid !== revision.uuid) {
            <!-- W67: any two revisions, side by side or overlaid (the last mode used) -->
            <button type="button" class="link-button history-compare mat-caption" data-testid="drawing-viewer-history-compare"
              (click)="compareWith(rev.uuid)">Compare with Rev {{ revision.label }}</button>
          }
        }
        <app-drawing-linked-panel class="linked-panel" [rows]="panelRows" [days]="panelDays" [totalRecords]="panelTotal" [start]="panelStart"
          [pageSize]="panelPageSize" [selectedUuid]="selected?.uuid ?? null" [loading]="panelLoading"
          (selectRecord)="selectFromPanel($event)" (openRecord)="openRecord($event)" (pageChange)="onPanelPage($event)" />
      </aside>
    </div>
  }
</div>

@if (redlining && editorConfig) {
  <app-markup-editor [config]="editorConfig" (saved)="onEditorSaved($event)" (closed)="onEditorClosed()"></app-markup-editor>
}
